import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { companyUserList } from 'actions/company';

import { Link } from 'react-router';
import NotFound from 'components/NotFound';
import NavBarConfig from 'components/NavBarConfig';
import CompanyUserList from 'components/companyUser/CompanyUserList';

const messages = defineMessages({
  BACK: {
    id: 'CompanyUserListPage.BACK',
    defaultMessage: 'Zurück',
  },
  USER: {
    id: 'CompanyUserListPage.USER',
    defaultMessage: 'Benutzer',
  },
  APPLY_USER: {
    id: 'CompanyUserListPage.APPLY_USER',
    defaultMessage: 'Benutzer anlegen',
  },
  TEAM_MANAGEMENT: {
    id: 'CompanyUserListPage.TEAM_MANAGEMENT',
    defaultMessage: 'Team Management',
  },
  SEARCH: {
    id: 'CompanyUserListPage.SEARCH',
    defaultMessage: 'Suchen...',
  },
  CREATE_USER: {
    id: 'CompanyUserListPage.CREATE_USER',
    defaultMessage: 'Benutzer anlegen',
  },
});

@injectIntl
@connect(
    state => state.companyUserList,
    (dispatch, props) => ({
        load: () => dispatch(companyUserList.load(props.params.companyId)),
    })
)

export default class CompanyUserListPage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            filter: ''
        };
    }

    componentWillMount() {
        this.props.load();
    }
    
    componentWillReceiveProps(nextProps) {
        if (this.props.params.companyId !== nextProps.params.companyId) {
            nextProps.load();
        }
    }

    handleSearchChange = (e) => {
        this.setState({ filter: e.target.value });
    }

    render() {
        const { user, company, companyMembership, results, routes, intl: { formatMessage } } = this.props;
        const { filter } = this.state;
        
        if (!company || !companyMembership) { return null; }
        const isGlobalAdmin = user && user.is_admin;
        const isCompanyAdmin = companyMembership && (companyMembership.is_owner || companyMembership.is_admin);
        if (!isGlobalAdmin && !isCompanyAdmin) {
          return <NotFound />;
        }
        
        return (
          <div style={{ padding: '16px', backgroundColor: 'transparent', minHeight: '100vh', width: '100%' }}>
            <NavBarConfig companyUserList currentRouteName={routes[routes.length - 1].name} />
            
            <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '16px' }}>
                <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '12px', color: 'var(--text-color)' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: 'var(--panel-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', fontSize: '18px', border: '1px solid var(--panel-border)' }}>
                    <i className="fa fa-users" />
                  </div>
                  <div>
                    {formatMessage(messages.TEAM_MANAGEMENT)}
                    <span style={{ display: 'block', fontSize: '14px', fontWeight: 'normal', color: 'var(--text-muted)', marginTop: '4px' }}>
                      {company.name}
                    </span>
                  </div>
                </h2>
                
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'nowrap' }}>
                  <div style={{ position: 'relative', flex: '1 1 auto', minWidth: '120px' }}>
                    <i className="fa fa-search" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
                    <input
                      style={{ padding: '0 12px 0 32px', height: '38px', boxSizing: 'border-box', borderRadius: '8px', border: '1px solid var(--input-border)', backgroundColor: 'var(--input-bg)', color: 'var(--input-text)', outline: 'none', width: '100%', maxWidth: '250px', fontSize: '14px' }}
                      type="text"
                      placeholder={formatMessage(messages.SEARCH)}
                      value={filter}
                      onChange={this.handleSearchChange}
                    />
                  </div>

                  <Link 
                    className="lh-btn lh-btn-primary"
                    to={`/company/${company.id}/user/create/`}
                    style={{ height: '38px', boxSizing: 'border-box', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap' }}
                  >
                    <span className="fa fa-user-plus" />
                    {' '}{formatMessage(messages.CREATE_USER)}
                  </Link>
                </div>
              </div>

              <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '12px', boxShadow: '0 4px 6px -1px var(--panel-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
                <CompanyUserList items={results} filter={filter} company={company} isGlobalAdmin={user && user.is_admin} isCompanyAdmin={isCompanyAdmin} />
              </div>
            </div>
          </div>
        );
    }
}
